import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28 flex flex-col items-center text-center">
      <span className="font-heading font-bold text-6xl md:text-8xl text-primary-200 select-none">
        404
      </span>
      <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-4">
        页面不存在或已被移动
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
        你访问的地址可能输入有误，或对应内容已调整。可以返回首页，或前往分类页继续浏览韩国伦理影视作品。
      </p>
      <p className="mt-2 text-xs text-foreground-400 break-all">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="px-5 h-11 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
        <Link
          to="/category/erotic"
          className="px-5 h-11 inline-flex items-center rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-300 transition-colors"
        >
          浏览分类
        </Link>
      </div>
    </div>
  );
}